import React, {useState} from "react"
import MetaTags from 'react-meta-tags';
import {
  Container, 
  Card, CardBody,
  CardTitle, CardSubtitle,
  CardText, CardHeader, 
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  Button,
  TabContent, 
  TabPane,
  Row, 
  Col,
  Input,
  Table,
  Alert
} from "reactstrap"
import { Link, useHistory } from "react-router-dom"
import { get, post } from "../../../helpers/api_helper"
import * as url from "../../../helpers/url_helper"
import cogoToast from 'cogo-toast';
import Select from "react-select"

const NewBlock = props => {

  const history = useHistory();

  const [name, setName] = useState('');
  const [property, setProperty] = React.useState(null);
  const [status, setStatus] = React.useState(1);

  const [properties, setProperties] = React.useState([]);

  const [errors, setErrors] = React.useState([]);

  
  const [loading, setLoading] = React.useState(false);
  const [initializing, setInitializing] = React.useState(true);

  const fetchData = (id) => {
    setLoading(true);
      console.log('Fetching ', id);
      get(url.GET_BLOCK+'/'+id).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setName(response.data.name);
        setProperty({value: response.data.property.id, label: response.data.property.name});
        // setProperty(response.data.property_id == null ? 'null' : response.data.property_id);
        setStatus(response.data.status);
        setLoading(false);
      }
      else {
        cogoToast.error('Could not fetch block data');
        setLoading(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });
  };

  const init = () => {
    setInitializing(true);
      get(url.GET_NEW_BLOCK).then(response => {
      console.log('RESP', response);
      if(response.status == 200) {
        setProperties(response.data.properties);
        setInitializing(false);
      }
      else {
        cogoToast.error('Could not fetch data');
        setInitializing(false);
      }
    })
    .catch(error => {
      console.log('err:', error);
    });

  }


  const handleSubmit = () => {
    if(name == '') {
      cogoToast.error('Block name is required');
      return;
    }
    if(property === null) {
      cogoToast.error('Property is required');
      return;
    }

    let data = {
      id: props.match.params.id ? props.match.params.id : 'new',
      name: name,
      status: status,
      property_id: property == null ? null : property.value,
      // repeat: repeat ? 1 : 0,
    };

    console.log('data', data);
    // return;

    setLoading(true);
    setErrors([]);
    // axios.post('/api/beacon/create', {
    post(url.POST_NEW_BLOCK, data)
    .then((response) => {
      console.log('RESP', response);
      if(response.status == 200) {
        history.push('/blocks/index');
        cogoToast.success('Block '+ (props.match.params.id ? (props.match.params.id == 'new' ? 'added' : 'updated') : 'added') + ' successfully');
      }
      else if(response.status == 400) {
        setErrors(Object.values(response.error));
      }
      else {
        console.log('err::', response);
      }
      // if(response == true) {
      // }
      // if(response.status == 200) {
      //   if(response.data == 'input') {
      //     cogoToast.error('Please check your input');
      //     setLoading(false);
      //   }
      //   else if(response.data == 'exists') {
      //     cogoToast.error('Beacon name is already taken');
      //     setLoading(false);
      //   }
      //   else {
      //     props.insertItem(response.data);
      //   }
      // }
      // else {
      //   cogoToast.error('Beacon could not be created');
      //   setLoading(false);
      // }
    }, (error) => {
      console.log(error);
      setLoading(false);
    });

  };

  React.useEffect(()=>{
    init();

    // console.log(props.match.params.id);

    if(props.match.params.id && props.match.params.id !== 'new') {
      // setName(props.match.params.id.name);
      fetchData(props.match.params.id);
    }
  }, []);

  // console.log('params:', props.match.params.id);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{props.match.params.id ? (props.match.params.id == 'new' ? 'Add New' : 'Edit') : 'Add New'} Block | Digital Logbook</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">{props.match.params.id ? (props.match.params.id == 'new' ? 'New' : 'Edit') : 'New'} Block</h3>
            <Link className="btn btn-secondary" to="/blocks/index">Back</Link>
          </div>


          {errors.length > 0 &&
          <div className="mt-3 mb-5">
            {errors.map((error, errorIdx)=>(
              <Alert key={errorIdx} color="danger">
                <i className="mdi mdi-alert-circle-outline me-2"></i>{error}
              </Alert>
            ))}
          </div>
          }

          <Card>
            <CardBody>
              {/* <CardTitle tag="h3">BASIC DETAILS</CardTitle> */}
              {/* <CardSubtitle tag="h5" className="mb-4 text-muted">22 Jul 2021</CardSubtitle> */}
              <div className="row mt-2">
                <div className="col">
                  <div className="mb-4 row">
                    <label htmlFor="activityName" className="col-sm-3 col-form-label">Block Name</label>
                    <div className="col-sm-9">
                      <input autoFocus type="text" className="form-control" id="name"  value={name} onChange={e=>{ setName(e.target.value); }} 
                        onKeyPress={(e) => { if(e.charCode == 13) { handleSubmit(); } }}
                        />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="property" className="col-sm-3 col-form-label">Property</label>
                    <div className="col-sm-9">
                      {/* <select className="form-control" placeholder="Select one" 
                        value={property}
                        onChange={(e)=>{ setProperty(e.target.value); }}
                        >
                        <option value="null">Select one</option>
                        {properties.map((prop, propIdx)=>(
                          <option key={propIdx} value={prop.id}>{prop.name}</option>
                        ))}
                      </select> */}

                      <Select
                        classNamePrefix="select2-selection"
                        placeholder="Select one"
                        title="Properties"
                        options={properties}
                        value={property}
                        onChange={e=>{setProperty(e);}}
                        />
                    </div>
                  </div>
                  <div className="mb-4 row">
                    <label htmlFor="status" className="col-sm-3 col-form-label">Status</label>
                    <div className="col-sm-9">
                      <select className="form-control" placeholder="Select one" 
                        value={status}
                        onChange={(e)=>{ setStatus(e.target.value); }}
                        >
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </CardBody>
          </Card>


     </Container>

    <div className="mb-4 container">
      <div className="d-flex justify-content-center">
        <button type="button" className="btn btn-primary me-2" onClick={()=>{ handleSubmit(); }}>Submit</button>
        <Link className="btn btn-light" to="/blocks/index">Cancel</Link>
      </div>
    </div>
      </div>
    </React.Fragment>
  )
}

export default NewBlock
